// extracted by mini-css-extract-plugin
export default {"cls1":"Reader-cls1_E9e","cls2":"Reader-cls2_A__ Reader-cls1_E9e","fullWidth":"Reader-fullWidth_zXn"};